/**
 *
 * @module dustSdkPayload
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../../exception/invalidArgumentException';

const {
    string
} = Check.assert;

/**
 *
 * @class DustSdkPayload
 * @since 3.4.0
 * @desc contains information specific to this SDK version
 *
 */
export default class DustSdkPayload {

    /**
     *
     * @access private
     * @param {String} [version='']
     * @param {String} [platform='']
     * @throws {InvalidArgumentException}
     *
     */
    constructor(version = '', platform = '') {

        const errorMessage = {
            ctor: 'DustPayload(server, client)',
            get version() {
                return `${this.ctor} needs a DustServerPayload instance`;
            },
            get platform() {
                return `${this.ctor} needs a DustClientPayload instance`;
            }
        };

        string(version, errorMessage.version, InvalidArgumentException);
        string(platform, errorMessage.platform, InvalidArgumentException);

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.version = version;

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.platform = platform;

    }

}



// WEBPACK FOOTER //
// ./src/services/internal/dust/dustSdkPayload.js